import React from "react";
import { Card, Form, Input, Button } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { IUserSystem } from "../../models/Users";
import { useChangePassword } from "../../query/UserQuery";
import { notify } from "../../utils/toast";

interface PasswordFormProps {
  selectedUser: IUserSystem;
}

const PasswordForm: React.FC<PasswordFormProps> = ({ selectedUser }) => {
  const [form] = Form.useForm();
  const changePasswordMutation = useChangePassword();
  return (
    <Card title="Đổi mật khẩu">
      <Form
        form={form}
        layout="vertical"
        onFinish={(values) => {
          form.resetFields();
        }}
      >
        <Form.Item
          name="newPassword"
          label="Mật khẩu mới"
          rules={[
            { required: true, message: "Vui lòng nhập mật khẩu mới" },
            { min: 8, message: "Mật khẩu phải có ít nhất 8 ký tự" },
            {
              pattern: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
              message: "Mật khẩu phải chứa chữ hoa, chữ thường và số",
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Xác nhận mật khẩu mới"
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "Vui lòng xác nhận mật khẩu mới" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Mật khẩu xác nhận không khớp")
                );
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button
            onClick={async () => {
              try {
                const values = await form.validateFields();
                await changePasswordMutation.mutateAsync({
                  id: selectedUser.id,
                  password: values.newPassword,
                });
                notify.success("Cập nhật mật khẩu thành công");
                form.resetFields();
              } catch (error) {
                notify.error("Cập nhật mật khẩu thất bại");
              }
            }}
            loading={changePasswordMutation.isPending}
            type="primary"
            htmlType="submit"
            icon={<LockOutlined />}
          >
            Cập nhật mật khẩu
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default PasswordForm;
